import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import React, { memo } from 'react'
import type { DateTimeFormat } from './dateTimeFormats'
import { DATE_TIME_FORMATS } from './dateTimeFormats'

interface BaseProps {
  value: Date | moment.Moment | string
}

interface PropsWithFormat extends BaseProps {
  format: DateTimeFormat
}

interface PropsWithOptions extends BaseProps, Intl.DateTimeFormatOptions {
  format?: undefined
}

function isPropsWithOptions(props: Props): props is PropsWithOptions {
  return props.format === undefined
}

type Props = PropsWithFormat | PropsWithOptions

/**
 * [MDN Reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#date-time_component_options)
 */
function FormatDateTime(props: Props) {
  const formatter = useIntlDateFormatter()

  if (isPropsWithOptions(props)) {
    const { value, ...options } = props
    return <>{formatter(value, options)}</>
  } else {
    const { value, format } = props
    return <>{formatter(value, DATE_TIME_FORMATS[format])}</>
  }
}

export default memo(FormatDateTime)
